import { useState, useEffect } from "react";

/**
 * Custom hook to detect if the viewport is mobile/tablet-portrait size (< 1024px).
 * 1024px+ (tablet landscape and desktop) uses the full desktop layout.
 * Updates on window resize.
 * @returns boolean - true if viewport width is less than 1024px
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Check on mount
    checkMobile();

    // Add resize listener
    window.addEventListener("resize", checkMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
}
